// Full-bleed autoplay hero video. Muted, looping, playsInline.
// Poster frame extracted from the same source. object-cover so it fills the
// hero area cleanly on any aspect ratio. CTA sits at the BOTTOM of the hero
// and smooth-scrolls to the CATEGORIES section (three category choices).
export default function Hero() {
  const scrollToCategories = () => {
    const el = document.getElementById("categories");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <section id="top" data-testid="hero-section" className="relative w-full overflow-hidden bg-black text-white">
      <div className="relative w-full h-[70vh] md:h-[86vh]">
        <video data-testid="hero-video"
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay muted loop playsInline preload="auto">
          <source src="/assets/hero/hero-video.webm" type="video/webm" />
          <source src="/assets/hero/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/80 pointer-events-none" />

        {/* Bottom-anchored CTA */}
        <div className="relative z-10 h-full flex items-end justify-center px-4 md:px-10 pb-10 md:pb-14">
          <button
            data-testid="hero-preview-cta"
            onClick={scrollToCategories}
            className="inline-flex items-center justify-center bg-[#F4C10A] text-black font-display uppercase text-sm md:text-base tracking-[0.28em] px-10 md:px-14 py-4 md:py-5 hover:bg-white transition-colors shadow-xl"
          >
            Shop the Collection
          </button>
        </div>
      </div>
    </section>
  );
}
